import { cva, VariantProps } from 'class-variance-authority';
import styles from './foregroundColor.module.css';
import type { InputType } from 'storybook/internal/types';

export const foregroundColorVariants = cva('', {
  variants: {
    foregroundColor: {
      default: styles['foregroundColor-primary'],
      primary: styles['foregroundColor-primary'],
      secondary: styles['foregroundColor-secondary'],
      accentPrimary: styles['foregroundColor-accent-primary'],
      accentSecondary: styles['foregroundColor-accent-secondary'],
      accentOnVibrant: styles['foregroundColor-accent-on-vibrant'],
      accentOnVibrantAccent: styles['foregroundColor-accent-on-vibrant-accent'],
      accentOnSubtle: styles['foregroundColor-accent-on-subtle'],
      accentOnDeep: styles['foregroundColor-accent-on-deep'],
      criticalPrimary: styles['foregroundColor-critical-primary'],
      criticalOnVibrant: styles['foregroundColor-critical-on-vibrant'],
      criticalOnSubtle: styles['foregroundColor-critical-on-subtle'],
      warningPrimary: styles['foregroundColor-warning-primary'],
      warningOnVibrant: styles['foregroundColor-warning-on-vibrant'],
      warningOnSubtle: styles['foregroundColor-warning-on-subtle'],
      cautionPrimary: styles['foregroundColor-caution-primary'],
      cautionOnVibrant: styles['foregroundColor-caution-on-vibrant'],
      cautionOnSubtle: styles['foregroundColor-caution-on-subtle'],
      successPrimary: styles['foregroundColor-success-primary'],
      successOnVibrant: styles['foregroundColor-success-on-vibrant'],
      successOnSubtle: styles['foregroundColor-success-on-subtle'],
      informationPrimary: styles['foregroundColor-information-primary'],
      informationOnVibrant: styles['foregroundColor-information-on-vibrant'],
      informationOnSubtle: styles['foregroundColor-information-on-subtle'],
      inversePrimary: styles['foregroundColor-inverse-primary'],
      inverseOnVibrant: styles['foregroundColor-inverse-on-vibrant'],
      inverseOnSubtle: styles['foregroundColor-inverse-on-subtle'],
      whitePrimary: styles['foregroundColor-white-primary'],
      whiteOnVibrant: styles['foregroundColor-white-on-vibrant'],
      whiteOnSubtle: styles['foregroundColor-white-on-subtle'],
      disabledPrimary: styles['foregroundColor-disabled-primary'],
      disabledOnVibrant: styles['foregroundColor-disabled-on-vibrant'],
      disabledOnSubtle: styles['foregroundColor-disabled-on-subtle'],
      salePrimary: styles['foregroundColor-sale-primary'],
      saleOnVibrant: styles['foregroundColor-sale-on-vibrant'],
    },
  },
});

export type ForegroundVariants = VariantProps<typeof foregroundColorVariants>;

export const foregroundColorOptions: ForegroundVariants['foregroundColor'][] = [
  'default',
  'primary',
  'secondary',
  'accentPrimary',
  'accentSecondary',
  'accentOnVibrant',
  'accentOnVibrantAccent',
  'accentOnSubtle',
  'accentOnDeep',
  'criticalPrimary',
  'criticalOnVibrant',
  'criticalOnSubtle',
  'warningPrimary',
  'warningOnVibrant',
  'warningOnSubtle',
  'cautionPrimary',
  'cautionOnVibrant',
  'cautionOnSubtle',
  'successPrimary',
  'successOnVibrant',
  'successOnSubtle',
  'informationPrimary',
  'informationOnVibrant',
  'informationOnSubtle',
  'inversePrimary',
  'inverseOnVibrant',
  'inverseOnSubtle',
  'whitePrimary',
  'whiteOnVibrant',
  'whiteOnSubtle',
  'disabledPrimary',
  'disabledOnVibrant',
  'disabledOnSubtle',
  'salePrimary',
  'saleOnVibrant',
];

export const foregroundColorArgTypes: Record<string, InputType> = {
  foregroundColor: {
    control: 'select',
    options: foregroundColorOptions,
    description:
      'Text/foreground color of the component. Use semantic color tokens that ensure proper contrast with backgrounds.',
    table: {
      type: { summary: 'ForegroundColor' },
      category: 'Foreground',
    },
  },
};
